<div class="main-container" [dir]="dir"
    [ngClass]="{'minisidebar': minisidebar, 'boxed': boxed, 'danger': danger, 'blue': blue, 'green': green, 'dark': dark }">
    <mat-toolbar color="primary" class="topbar telative">
        <div class="navbar-header">
            <a class="navbar-brand" href="/">
                <b>
                    <img src="{{imgUrl}}logo-light-icon.png" alt="homepage" class="light-logo">
                </b>
                <span fxShow="false" fxShow.gt-xs>
                    <img src="{{imgUrl}}logo-light-text.png" class="light-logo" alt="homepage">
                </span>
            </a>
        </div>
        <button mat-icon-button (click)="snav.toggle()" value="sidebarclosed">
            <mat-icon>menu</mat-icon>
        </button>
        <button mat-icon-button class="srh-btn">
            <mat-icon>search</mat-icon>
        </button>
        <form class="app-search">
            <input type="text" class="form-control" placeholder="Search &amp; enter">
            <a class="cl-srh-btn">
                <i class="ti-close"></i>
            </a>
        </form>
        <span fxFlex></span>
        <app-header></app-header>
        <button (click)="end.toggle()" mat-icon-button class="ml-xs overflow-visible">
            <mat-icon>settings</mat-icon>
        </button>
    </mat-toolbar>
    <mat-progress-bar mode="indeterminate" color="accent" *ngIf="isShow"></mat-progress-bar>
    <mat-sidenav-container [style.marginTop.px]="mobileQuery.matches ? 0 : 0"
        [ngClass]="{'minisidebar': minisidebar}">
        <mat-sidenav #snav id="snav" class="pl-xs" [mode]="mobileQuery.matches ? 'side' : 'over'" fixedTopGap="0"
            [opened]="mobileQuery.matches" [disableClose]="mobileQuery.matches" [perfectScrollbar]="config">
            <app-sidebar class="app-sidebar"></app-sidebar>
        </mat-sidenav>
        <mat-sidenav #end position="end" class="chat-panel" mode="over" opened="false">
            <div class="scroll">
                <mat-nav-list>
                    <h3 mat-subheader class="text-uppercase font-weight-bold">Settings</h3>
                    <mat-list-item>
                        <mat-slide-toggle color="warn" (change)="dir = (dir == 'rtl' ? 'ltr' : 'rtl')">RTL
                        </mat-slide-toggle>
                    </mat-list-item>
                    <mat-list-item>
                        <mat-slide-toggle color="warn" [(ngModel)]="boxed">Boxed Layout</mat-slide-toggle>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                    <h3 mat-subheader class="text-uppercase font-weight-bold">Colors</h3>
                    <mat-list-item>
                        <mat-checkbox color="warn" [(ngModel)]="danger" (change)="green = blue = false"
                            class="text-danger">Red</mat-checkbox>
                    </mat-list-item>
                    <mat-list-item>
                        <mat-checkbox color="warn" [(ngModel)]="green" (change)="danger = blue = false"
                            class="text-megna">Teal Green
                        </mat-checkbox>
                    </mat-list-item>
                    <mat-list-item>
                        <mat-checkbox color="warn" [(ngModel)]="blue" (change)="green = danger = false"
                            class="text-info">Blue</mat-checkbox>
                    </mat-list-item>
                    <mat-list-item>
                        <mat-checkbox color="warn" [(ngModel)]="dark" (change)="green = blue = danger = false">Dark
                        </mat-checkbox>
                    </mat-list-item>
                </mat-nav-list>
            </div>
        </mat-sidenav>
        <mat-sidenav-content class="page-wrapper">
            <div class="page-content">
                <router-outlet>
                    <app-spinner></app-spinner>
                </router-outlet>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
    <!-- <div fxLayout="row" class="footer" fxLayoutAlign="center center">
        <img fxFlex.lt-sm="80" fxFlex="20" src="assets/images/background/footer-logo.png" alt="homepage">
    </div> -->
</div>